/* assets/vijvercheck-keyword-linker.js
 *
 * VijverCheck keyword auto-link
 * ─────────────────────────────
 * Scant advies-copy en linkt eerste voorkomen van elk keyword naar de
 * juiste Vijvercentrum-collectie of /search?q= fallback. Pure ES5 IIFE,
 * geen build-step nodig.
 *
 * Public API:
 *   window.VijverCheck.linkKeywords(rootEl)
 *
 * Veiligheid:
 *   - skips <a>, <h1>-<h3>, <button>, <code>
 *   - skips elementen met [data-vw-no-link] of [data-vw-product]
 *   - skips text nodes binnen al-gelinkte/anchor scope
 *   - eerste match per text-node (geen 5x dezelfde paragraaf linken)
 *   - DOM-replacement via createElement, GEEN innerHTML
 *
 * Tracking:
 *   - track('vw_keyword_link_click', {keyword, href}) bij click
 *   - gebruikt window.VijverCheck.track() als beschikbaar
 */
(function () {
  'use strict';

  // Geverifieerd (Agent 4, 2026-05-26): alleen published:true collecties.
  // Search-fallback voor concepten zonder dedicated collectie.
  var KEYWORD_MAP = {
    // Beluchting / luchtpompen
    'luchtpomp': '/collections/luchtpompen-beluchting',
    'luchtpompen': '/collections/luchtpompen-beluchting',
    'beluchting': '/collections/luchtpompen-beluchting',
    'membraanpomp': '/collections/luchtpompen-beluchting',
    // UV-C
    'uv-c unit': '/collections/uvc-units',
    'uv-c apparaat': '/collections/uvc-units',
    'uv-c-lamp': '/collections/uvc-vervanglampen',
    'uv-c lamp': '/collections/uvc-vervanglampen',
    'kwartsglas': '/collections/uvc-vervanglampen',
    'vervanglamp': '/collections/uvc-vervanglampen',
    // Algen
    'draadalg': '/collections/draadalg-bestrijden',
    'groen water': '/collections/zweefalg-bestrijden',
    'zweefalg': '/collections/zweefalg-bestrijden',
    'heldermaker': '/collections/helder-vijverwater-krijgen',
    'vlokmiddel': '/collections/helder-vijverwater-krijgen',
    // Pompen / filters
    'vijverpomp': '/collections/vijverpompen',
    'drukfilter': '/collections/drukfilters',
    'trommelfilter': '/collections/trommelfilters',
    // Bacteriën / starter
    'vijverbacteri': '/collections/vijverbacterien',
    'bacteriestarter': '/collections/vijverbacterien',
    'vijverbacterien': '/collections/vijverbacterien',
    'vijverbacterie': '/collections/vijverbacterien',
    'visziekten': '/collections/visziekten-medicijnen',
    'nitraatverwijderaar': '/search?q=nitraatverwijderaar',
    // Zuurstof / temperatuur
    'zuurstoftekort': '/collections/zuurstoftekort-oplossen',
    // Water-tests + visziekten
    'watertest': '/collections/water-testen-meten',
    'visziekt': '/collections/visziekten-medicijnen',
    'visziekte': '/collections/visziekten-medicijnen',
    'medicatie': '/collections/visziekten-medicijnen',
    // Verbeteraars / slib
    'waterverbeteraar': '/collections/waterverbeteraars',
    'bodemslib': '/collections/bodemslib-verwijderen',
    'schepnet': '/collections/schepnetten-meetbakken',
    // Filtermedia
    'filtermedia': '/collections/filtermedia',
    'matala': '/collections/filtermedia',
    // Stofzuiger + verwarming
    'vijverstofzuiger': '/collections/vijverstofzuigers',
    'ijsvrijhouder': '/collections/vijververwarming-ijsvrijhouders',
    'vijververwarming': '/collections/vijververwarming-ijsvrijhouders',
    // Search-fallback (geen dedicated collectie)
    'fosfaatbinder': '/search?q=fosfaatbinder',
    'ammoniakbinder': '/search?q=ammoniakbinder',
    'zeoliet': '/search?q=zeoliet',
    'vijverzout': '/search?q=vijverzout',
    'bicarbonaat': '/search?q=bicarbonaat',
    'kh-buffer': '/search?q=KH-buffer',
    'maerl': '/search?q=Maerl',
    'maërl': '/search?q=Maerl',
    'oesterschelp': '/search?q=oesterschelp',
    'nitraatverwijder': '/search?q=nitraatverwijderaar'
  };

  // Sorteer keys langst-eerst, anders zou "uv-c" eerder matchen dan "uv-c lamp"
  var KEYWORDS_SORTED = Object.keys(KEYWORD_MAP).sort(function (a, b) {
    return b.length - a.length;
  });

  // Word-boundary escape: regex-special chars in keys (zoals "-") moeten letterlijk
  function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Skip-elementen: anchor, heading, button, code, no-link markers
  var SKIP_TAGS = { A: 1, H1: 1, H2: 1, H3: 1, BUTTON: 1, CODE: 1, SCRIPT: 1, STYLE: 1 };

  function shouldSkip(node) {
    var p = node && node.parentNode;
    while (p && p.nodeType === 1) {
      if (SKIP_TAGS[p.tagName]) return true;
      if (p.hasAttribute && (p.hasAttribute('data-vw-no-link') || p.hasAttribute('data-vw-product'))) return true;
      p = p.parentNode;
    }
    return false;
  }

  function track(evt, payload) {
    try {
      if (window.VijverCheck && typeof window.VijverCheck.track === 'function') {
        window.VijverCheck.track(evt, payload);
      } else if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: evt, vw: payload });
      }
    } catch (_) { /* tracking nooit blokkerend */ }
  }

  function buildAnchor(matchText, href, keyword) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = matchText;
    a.setAttribute('data-vw-kw-link', '1');
    a.setAttribute('data-vw-keyword', keyword);
    a.className = 'vw-kw-link underline decoration-aqua/40 underline-offset-2 hover:decoration-aqua';
    a.addEventListener('click', function () {
      track('vw_keyword_link_click', { keyword: keyword, href: href });
    });
    return a;
  }

  /**
   * Verwerk één text-node: pak eerste-match keyword (in sortvolgorde, langst eerst),
   * splits node in {pre, anchor, post}, returnt aantal vervangingen (0 of 1).
   */
  function processTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || text.length < 3) return 0;

    var bestIdx = -1;
    var bestKw = null;
    var bestMatch = null;

    for (var i = 0; i < KEYWORDS_SORTED.length; i++) {
      var kw = KEYWORDS_SORTED[i];
      // Word-boundary: vóór match: start-of-string OF non-word-char (incl. UTF-8 punctuatie)
      // Na match: eind-of-string OF non-word-char. Eigen helper want \b werkt slecht
      // met UTF-8 en koppelteken in "uv-c".
      var re = new RegExp('(^|[^\\p{L}\\p{N}_-])(' + escapeRegex(kw) + ')(?=$|[^\\p{L}\\p{N}_-])', 'iu');
      var m = re.exec(text);
      if (m) {
        var idx = m.index + m[1].length;
        if (bestIdx === -1 || idx < bestIdx) {
          bestIdx = idx;
          bestKw = kw;
          bestMatch = m[2];
        }
      }
    }

    if (bestIdx === -1) return 0;

    var href = KEYWORD_MAP[bestKw];
    var before = text.slice(0, bestIdx);
    var after = text.slice(bestIdx + bestMatch.length);

    var parent = textNode.parentNode;
    if (!parent) return 0;

    var anchor = buildAnchor(bestMatch, href, bestKw);

    if (before) parent.insertBefore(document.createTextNode(before), textNode);
    parent.insertBefore(anchor, textNode);
    if (after) parent.insertBefore(document.createTextNode(after), textNode);
    parent.removeChild(textNode);
    return 1;
  }

  function linkKeywords(rootEl) {
    if (!rootEl || rootEl.nodeType !== 1) return 0;
    // Verzamel eerst alle text-nodes (geen live walk, anders kunnen we
    // de freshly-inserted anchors gaan re-processsen)
    var walker = document.createTreeWalker(
      rootEl,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (n) {
          if (!n.nodeValue || !/\S/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
          if (shouldSkip(n)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      },
      false
    );
    var nodes = [];
    var cur;
    while ((cur = walker.nextNode())) nodes.push(cur);

    var total = 0;
    for (var i = 0; i < nodes.length; i++) {
      total += processTextNode(nodes[i]);
    }
    return total;
  }

  // ── Expose op window.VijverCheck (extend, niet overschrijven) ──
  function expose() {
    window.VijverCheck = window.VijverCheck || {};
    window.VijverCheck.linkKeywords = linkKeywords;
    window.VijverCheck.KEYWORD_MAP = KEYWORD_MAP;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', expose);
  } else {
    expose();
  }
})();
